import { Action, createReducer, on } from '@ngrx/store';
import { SiteDto } from 'src/app/api/models';
import { loadSiteByCity_Failure, loadSiteByCity_Success, resetSite } from './site.actions';


export const siteFeatureKey = 'site';

export interface SiteState {
  siteList: SiteDto[];

}

export const initialState: SiteState = {
  siteList: undefined
};


export const siteReducer = createReducer(
  initialState,
	on(loadSiteByCity_Success, (state, { data }) => ({ ...state, siteList: data })),
	on(resetSite, () => initialState)
);
